export default "__VITE_ASSET__DMSnpEpG__"